import { translate } from "@/plugins/i18n";
import type BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";
import { Maybe } from "@/components/utils/typeHelpers";


export class EnumStockUom implements BaseEnumType {
  private static allValues: EnumStockUom[] = []; // make sure this is top-most
  
  public static units = new EnumStockUom(0, "Units", "enum_stock_uom_units");
  public static barrels = new EnumStockUom(1, "Barrels", "enum_stock_uom_barrels");
  public static litres = new EnumStockUom(2, "Litres", "enum_stock_uom_litres");
  public static hectolitres = new EnumStockUom(3, "Hectolitres", "enum_stock_uom_hectolitres");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumStockUom.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isUnits() { return this === EnumStockUom.units; }
  public isBarrels() { return this === EnumStockUom.barrels; }
  public isLitres() { return this === EnumStockUom.litres; }
  public isHectolitres() { return this === EnumStockUom.hectolitres; }

  public static getValues(): readonly EnumStockUom[] {
    return EnumStockUom.allValues;
  }

  public static getValuesExcept0(): readonly EnumStockUom[] {
    return EnumStockUom.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumStockUom {
    const found = EnumStockUom.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumStockUom - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumStockUom): EnumStockUom {
    const found = name ? EnumStockUom.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumStockUom - Value not found: ${ name }`);
    }

    return found;
  }

  public equals(other: Maybe<EnumStockUom>): boolean {
    return this.key === other?.key;
  }
}